import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaArrowUpRightFromSquare, FaGlobe, FaMagnifyingGlass, FaPeopleGroup } from "react-icons/fa6";
import HomePage from "./HomePage";
import Footer from "./Footer";
import "./CSS/about.css";

const values = [
  {
    icon: <FaGlobe />,
    title: "A professional home online",
    copy: "Create a polished, mobile-ready website that makes it easy for customers to understand and contact your business.",
  },
  {
    icon: <FaMagnifyingGlass />,
    title: "Discovery built in",
    copy: "Your business profile and website work together, helping local buyers find the right provider with less friction.",
  },
  {
    icon: <FaPeopleGroup />,
    title: "Connections that matter",
    copy: "Buyers can share what they need and local businesses can turn genuine interest into new conversations.",
  },
];

const About = () => (
  <div className="about-page">
    <HomePage />

    <main>
      <section className="about-hero">
        <div className="about-hero-copy">
          <p className="about-eyebrow">ABOUT CIRCLEGRID</p>
          <h1>Helping local businesses<br /><em>show up and grow.</em></h1>
          <p className="about-lede">
            CircleGrid brings your website, business listing and customer connections
            into one straightforward platform.
          </p>
          <div className="about-actions">
            <Link className="about-primary-button" to="/Signup">Start building <FaArrowRight /></Link>
            <Link className="about-secondary-link" to="/Directory">Explore the directory <FaArrowRight /></Link>
          </div>
        </div>
        <div className="about-hero-art" aria-hidden="true">
          <div className="about-grid-card about-grid-card-main">
            <span>YOUR BUSINESS</span>
            <strong>One place to be<br />seen, trusted and found.</strong>
            <i />
          </div>
          <div className="about-grid-card about-grid-card-small">LOCAL<br /><b>+ visible</b></div>
          <span className="about-art-orbit" />
        </div>
      </section>

      <section className="about-story">
        <div>
          <p className="about-eyebrow">WHY WE EXIST</p>
          <h2>Good businesses deserve<br />a clearer path online.</h2>
        </div>
        <div className="about-story-copy">
          <p>
            Building an online presence can feel fragmented: one tool for a website,
            another for discovery, and another for finding new opportunities. CircleGrid
            is designed to bring those pieces together.
          </p>
          <p>
            We started with a business directory and grew into a practical home for local
            businesses to present their work, build credibility and connect with customers
            who are actively looking for help.
          </p>
        </div>
      </section>

      <section className="about-founder" aria-labelledby="about-founder-title">
        <div className="about-founder-profile" aria-hidden="true">
          <span>ZP</span>
          <div>
            <small>FOUNDER &amp; DIRECTOR</small>
            <strong>Zaahid Patel</strong>
          </div>
        </div>
        <div className="about-founder-copy">
          <p className="about-eyebrow">WHO LEADS CIRCLEGRID</p>
          <h2 id="about-founder-title">Built with local business<br />at its heart.</h2>
          <p>
            CircleGrid was founded and is led by Zaahid Patel, a MANCOSA graduate
            with experience in business development and digital marketing. He created
            CircleGrid to give local businesses a simpler way to build their online
            presence, get discovered and connect with customers.
          </p>
          <div className="about-founder-links">
            <a href="https://www.linkedin.com/in/zaahid-p-339435161/" target="_blank" rel="noreferrer">
              Connect on LinkedIn <FaArrowUpRightFromSquare />
            </a>
            <a href="https://www.mancosa.co.za/" target="_blank" rel="noreferrer">
              Visit MANCOSA <FaArrowUpRightFromSquare />
            </a>
          </div>
        </div>
      </section>

      <section className="about-values" aria-labelledby="about-value-title">
        <div className="about-section-heading">
          <p className="about-eyebrow">WHAT CIRCLEGRID DOES</p>
          <h2 id="about-value-title">The essentials, working together.</h2>
        </div>
        <div className="about-value-grid">
          {values.map((value) => (
            <article key={value.title}>
              <span>{value.icon}</span>
              <h3>{value.title}</h3>
              <p>{value.copy}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="about-two-paths">
        <div className="about-path about-path-business">
          <small>FOR BUSINESSES</small>
          <h2>Put your best work forward.</h2>
          <p>Build your site, strengthen your listing and make it easier for new customers to choose you.</p>
          <Link to="/Pricing">See plans <FaArrowRight /></Link>
        </div>
        <div className="about-path about-path-buyer">
          <small>FOR BUYERS</small>
          <h2>Find the right local help.</h2>
          <p>Tell us what you need and give relevant providers a chance to start the conversation.</p>
          <Link to="/buyers-portal">Find a provider <FaArrowRight /></Link>
        </div>
      </section>

      <section className="about-final-cta">
        <p className="about-eyebrow">GROW WITH CIRCLEGRID</p>
        <h2>Your next customer should<br />be able to find you.</h2>
        <Link className="about-primary-button" to="/Signup">Create your presence <FaArrowRight /></Link>
      </section>
    </main>

    <Footer />
  </div>
);

export default About;
